import { type ReactNode } from 'react';
import { cn } from '../../lib/utils';

/**
 * A small pill toggle for filter rows (e.g. the Cost Optimization board's Type/
 * Time filters, the Members role filter). Active = iris outline + tint.
 */
export function FilterChip({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'rounded-full border px-3 py-1 text-xs font-semibold transition-colors',
        active
          ? 'border-iris bg-iris/10 text-bone'
          : 'border-border bg-surface text-muted hover:text-bone',
      )}
    >
      {children}
    </button>
  );
}
